import React, { useEffect, useState } from 'react'
import { v2_projects, v2_ships } from '../../../actions/v2/projectAndVessel';
import constant from '../../../constant';
import { encodeBase64UrlJsonPayload } from '../../../utils';
import { useDebouncedValue } from '../../../customHook/useDebouncedValue';

const SearchFilter = ({ onSearch }) => {
    const [state, setState] = useState({
        formName: { name: 'formName', value: '', options: [] },
        project: { name: 'project', value: '', options: [] },
        ship: { name: 'ship', value: '', options: [] },
        startDate: { name: 'startDate', value: '' },
        endDate: { name: 'endDate', value: '' },
    })
    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                value,
            },
        }));
    };

    // Typing fires one request per keystroke otherwise, and the responses come
    // back out of order — that is the "sometimes works" the users see.
    const debouncedFormName = useDebouncedValue(state.formName.value, 400);

    useEffect(() => {
        v2_projects().then((res) => {
            if (res.status) {
                setState((prev) => ({
                    ...prev,
                    project: { ...prev.project, options: res.result },
                }));
            }
        });


    }, []);

    useEffect(() => {
        v2_ships(null, state.project.value).then((res) => {
            if (res.status) {
                setState((prev) => ({
                    ...prev,
                    // Drop a hull that the new parent no longer offers, otherwise the
                    // stale id stays in the filter and the list comes back empty.
                    ship: {
                        ...prev.ship,
                        options: res.result,
                        value: res.result.some((item) => String(item.ID) === String(prev.ship.value))
                            ? prev.ship.value
                            : '',
                    },
                }));
            }
        });

    }, [state.project.value]);

    useEffect(() => {
        onSearch(encodeBase64UrlJsonPayload({
            projectId: state.project.value,
            formName: debouncedFormName.trim(),
            shipId: state.ship.value,
            startDate: state.startDate.value,
            endDate: state.endDate.value,
        }))
    }, [state.project.value, state.ship.value, state.startDate.value, state.endDate.value, debouncedFormName])


    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body card-body-search">
                        <div
                            className="row gy-12 gx-12 align-items-center"
                        >
                            <div className="row">
                                <div className="form-group col-md-2">
                                    {/* <label htmlFor="inputEmail4" className="col-form-label">
                                        Report Name
                                    </label> */}
                                    <input
                                        className="form-control"
                                        type='text'
                                        placeholder='Report Name'
                                        value={state.formName.value}
                                        name={state.formName.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group col-md-2">
                                    {/* <label htmlFor="inputEmail4" className="col-form-label">
                                        Project
                                    </label> */}
                                    <select className="form-select"
                                        value={state.project.value}
                                        name={state.project.name}
                                        onChange={handleChange}
                                    >
                                        <option value="">All Projects</option>
                                        {state.project.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                                {item.PROJECT_CODE} - {item.PROJECT_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-2">
                                    {/* <label htmlFor="inputEmail4" className="col-form-label">
                                        Hull
                                    </label> */}
                                    <select className="form-select"
                                        value={state.ship.value}
                                        name={state.ship.name}
                                        onChange={handleChange}
                                    >
                                        <option value="">All Hull</option>

                                        {state.ship.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                                {item.HULL_NUMBER} - {item.SHIP_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-2">
                                    {/* <label htmlFor="inputState" className="col-form-label">
                                        Start Date
                                    </label> */}
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="START_DATE"
                                        value={state.startDate.value}
                                        name={state.startDate.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group col-md-2">
                                    {/* <label htmlFor="inputState" className="col-form-label">
                                        End Date
                                    </label> */}
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={state.endDate.value}
                                        name={state.endDate.name}
                                        onChange={handleChange}
                                        id="END_DATE"
                                    />
                                </div>
                                <div className="form-group col-md-2">

                                    <a
                                       href={constant.Authedcomponent.production.url}
                                        style={{
                                            backgroundImage: "linear-gradient(90deg, #6895b4, #265578)"
                                        }}
                                        className="btn btn-primary waves-effect waves-light"
                                    >
                                        {/* <i className="bx bx-cloud-download label-icon" /> */}
                                         Create New
                                        Report
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* end card body */}
                </div>
                {/* end card */}
            </div>
            {/* end col */}
        </div>

    )
}

export default SearchFilter